import appUtils from '../../app/lib/appUtil';
//由于语言后台与前端文件不一致，需要做映射
var LanMap = {
  'zh': 'zh',
  'en': 'en',
  'ja': 'ja',
  'zh-CN': 'zh',
  'en-US': 'en',
  'ja-JP': 'ja',
};
function hashString(str) {
  var hash = 5381,
    i = str.length;

  while (i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }

  /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
   * integers. Since we want the results to be always positive, convert the
   * signed int to an unsigned by doing an unsigned bitshift. */
  return hash >>> 0;
}
var hashKey = function (value) {
  return (
    'k_' + ('0000' + hashString(value.replace(/\s+/g, '')).toString(36)).slice(-7)
  );
};
// 当前语言
// 是否已经初始化
var hasInited = false;
var defaultNamespace = 'translation';
//语言关键字
var langKey = 'tce_language';

//默认加载的语言
var lng = window[langKey] || 'zh';

//保存传入参数
var _options;

var i18n = {
  /**
   * 初始化当前语言的国际化配置
   * {targetModule} 目标模块
   * {backend}
   * {callback}
   */
  init: function (options) {
    var i18next = window.i18next;
    var reacti18next = window.ReactI18next;
    var Backend = window.i18nextXHRBackend;
    var LngDetector = window.i18nextBrowserLanguageDetector;

    _options = options;
    lng = options[langKey] ? options[langKey] : lng;

    if (hasInited) {
      //当前模块，当前语言是否有加载
      console.warn('你已经初始化过 i18n，请勿重复初始化');
      //return;
    }
    hasInited = true;

    //异步加载
    var backendOption = options.backend;
    if (backendOption) {
      backendOption.parse =
        backendOption.parse ||
        function (data) {
          //data = data.replace("module.exports", "window.translation");
          //let lng = eval(data)
          //return lng.translation;
          return data;
        };
    }

    i18next
      .use(reacti18next.reactI18nextModule)
      .use(Backend)
      .use(LngDetector);

    // passes i18n down to react-i18next
    i18next.init(
      {
        backend: backendOption,
        detection: {
          lookupQuerystring: langKey,
          lookupCookie: langKey,
          lookupLocalStorage: langKey
        },
        // 使用语言
        //lng: "en",//采用LngDetector来识别 todo 优化
        // 英文版 fallback 到中文版，其它语言 fallback 到中文版
        //fallbackLng: lng === 'en' ? 'zh' : 'en',
        fallbackLng: 'zh',
        ns: options.ns || defaultNamespace,
        defaultNS: options.defaultNS || defaultNamespace,
        react: {
          hashTransKey: function (sentence) {
            var key = hashKey(sentence);
            return key;
          }
        }
      },
      function (err, t) {
        options.callback();
      }
    );
    //

    //同步语言
    var translationOption = options.translation;
    translationOption &&
      i18next.addResourceBundle(lang, defaultNamespace, translationOption);
  },

  /**
   * 标记翻译句子
   * 详细的标记说明，请参考 http://tapd.oa.com/QCloud_2015/markdown_wikis/view/#1010103951008390841
   */
  t: function (sentence, options) {
    var key = hashKey(sentence);
    var _options = options || {};
    _options.defaultValue = sentence;
    return i18next.t(key, _options);
  },
  /**
   * 修改语言
   */
  changeLanguage: function (lng, callback) {
    i18next.loadLanguages(lng).then(function () {
      i18next.changeLanguage(lng).then(function (t) {
        //界面重新刷新
        _options.callback(lng, t);
      });
    });
  },
  getLanguage: function () {
    return appUtils.getLanguage();;
  },
  getLoadLangName: function () {
    var lang = this.getLanguage()
    return LanMap[lang] || lang;
  }
};

export { i18n };
